export enum GroupCustomFieldTypeEnum {
  TEXT = 'text',
  SELECT = 'select_list'
}
